module.exports = __webpack_public_path__ + "img/rapi_about_one.1c507f37.png";